module.exports = __webpack_public_path__ + "static/media/app-image-with-text.35650750.png";